export default __webpack_public_path__ + "static/15-73102ef3145d751c9ee098acbffd20e1.png";